import { ASSETS } from "./api";

// Flies `count` icons from `fromRect` to `toRect` (lands at `toRect` icon spot or centre). Resolves when the last one lands.
export function currencyRain(fromRect, toRect, { count = 10, makeIcon, glow, duration = 850, stagger = 55, burst = 1, landCentre = false }) {
  if (!fromRect || !toRect) return Promise.resolve();
  const tx = landCentre ? toRect.left + toRect.width / 2 : toRect.left + 18;
  const ty = toRect.top + toRect.height / 2;
  const jobs = Array.from({ length: count }, (_, i) => {
    const el = makeIcon();
    if (!el) return Promise.resolve();
    el.setAttribute("data-testid", "currency-rain-icon");
    const sx = fromRect.left + fromRect.width * (0.2 + Math.random() * 0.6);
    const sy = fromRect.top + fromRect.height / 2;
    Object.assign(el.style, {
      position: "fixed", left: `${sx}px`, top: `${sy}px`, width: "30px", height: "30px", marginLeft: "-15px", marginTop: "-15px",
      zIndex: 9999, pointerEvents: "none", filter: `drop-shadow(0 0 8px ${glow})`, opacity: 0,
    });
    document.body.appendChild(el);
    const dx = tx - sx + (landCentre ? (Math.random() - 0.5) * 60 : 0), dy = ty - sy;
    const burstX = (Math.random() - 0.5) * 140 * burst, burstY = (-40 - Math.random() * 80) * burst;
    const anim = el.animate([
      { transform: "translate(0,0) scale(0.4) rotate(0deg)", opacity: 0 },
      { transform: `translate(${burstX}px, ${burstY}px) scale(1.25) rotate(${(Math.random() - 0.5) * 120}deg)`, opacity: 1, offset: 0.3 },
      { transform: `translate(${dx}px, ${dy}px) scale(0.55) rotate(${(Math.random() - 0.5) * 360}deg)`, opacity: 0.9 },
    ], { duration, delay: i * stagger, easing: "cubic-bezier(.5,0,.75,.6)", fill: "forwards" });
    return anim.finished.catch(() => {}).finally(() => el.remove());
  });
  return Promise.all(jobs);
}

export const rainCount = (amount) => Math.min(14, 6 + Math.floor(Math.log10((amount || 0) + 1) * 2));

const rectOf = (sel) => document.querySelector(sel)?.getBoundingClientRect();
const hotdogImg = () => { const el = document.createElement("img"); el.src = ASSETS.currency.hotdog; return el; };
const handshakeSvg = () => document.querySelector("[data-testid='handshake-icon']")?.cloneNode(true);

export const hotDogRain = (fromRect, opts = {}) =>
  currencyRain(fromRect, rectOf("[data-testid='currency-hotdogs']"), { glow: "#FFE600", makeIcon: hotdogImg, ...opts });

export const handshakeRain = (fromRect, opts = {}) =>
  currencyRain(fromRect, rectOf("[data-testid='currency-handshakes']"), { glow: "#00F0FF", makeIcon: handshakeSvg, ...opts });

// Spending: handshakes fly fast from the header balance into the bought card.
export const handshakeSpendRain = (toEl) =>
  currencyRain(rectOf("[data-testid='currency-handshakes']"), toEl?.getBoundingClientRect(),
    { glow: "#00F0FF", makeIcon: handshakeSvg, count: 7, duration: 420, stagger: 25, burst: 0.4, landCentre: true });
